import React, {ReactNode} from 'react';
import {FieldValues, UseFormHandleSubmit} from 'react-hook-form';
import {useSearchParams} from 'react-router-dom';
import {t} from '@lingui/core/macro';

import ModalBlockButton from 'shared/ui/Button/ModalBlockButton/ModalBlockButton';
import {applyUrlFilters, UrlFiltersData} from 'shared/lib/filterHelper';

import ModalBodyWrapper from '../ModalBodyWrapper';

import styles from './ListFiltersForm.module.scss';

interface IListFiltersFormProps<T extends FieldValues> {
    handleSubmit: UseFormHandleSubmit<T>,
    toFilters: (_values: T) => UrlFiltersData,
    onClose: () => void,
    children: ReactNode,
}

function ListFiltersForm<T extends FieldValues>({
    handleSubmit,
    toFilters,
    onClose,
    children,
}: IListFiltersFormProps<T>) {
    const [searchParams, setSearchParams] = useSearchParams();

    const onSubmit = (values: T) => {
        setSearchParams(applyUrlFilters(searchParams, toFilters(values)));
        onClose();
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
            <ModalBodyWrapper>
                {children}
            </ModalBodyWrapper>
            <ModalBlockButton
                primaryButtonText={t`Применить фильтры`}
                primaryButtonType="submit"
                secondaryButtonOnClick={onClose}
            />
        </form>
    );
}

export default ListFiltersForm;
